import React, {useEffect, useState, useRef} from 'react';
import Slider from 'react-slick';
import * as S from './style';
import UsePrevious from '../../common/hooks/usePreviousValue';
import { OnboardingCarousalActiveDotMovementIndex } from '../../../constant-data/splashverse-onboarding';
import Question from './question-component';
import { useDispatch, useSelector } from 'react-redux'
import { setQuestionOutcomeData, setSkipPersonalized, setQuestionResponsesData } from '../../../stores/splashverse-onboarding/actions';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { SubmitSurvey } from '../../../services/loggedout-api';
import { SubmitOnboardingSurvey } from '../../../services/parent-api';

const OnboardingQuestionCarousal = ({
    onboardingQuestions,
    goToNextHandler,
    showTransition,
    questionEventHandler,
    setQuestionDetailsForEvent,
    selectedSubject,
    childScreenName,
    isLPABTest=false,
    dataForQuestionsOutcome,
    setDataforQuestionOutcome,
    questionResponses,
    setQuestionResponses,
    attachRestOfTheOutcomeDataAndIndex,
    isNewCoqAbTest,
    studentId
  }) => {
  const { setValue } = useExtendedLocalStorage('splashverse-onboarding', '');
  let NumberOfQuestions = 0;

  onboardingQuestions && Object.keys(onboardingQuestions).forEach((que) => {
    if( onboardingQuestions[que].text !== 'NA') {
      NumberOfQuestions++;
    }
  })

  let { subjectCodeMap } = useSelector(state => {
    return {
      subjectCodeMap: state.subjectCodeMap,
    }
  });

  const [activeDotMovementValue, setActiveDotMovementValue] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [unclickableResponse, setUnclickableResponse] = useState(false);

  const dispatch = useDispatch();

  const sliderRef = useRef(null);

  const playAudio = (url) => {
    const audioPlayer = document.getElementById('audio-player-survey');
    audioPlayer.src = url;
    audioPlayer.play();
  }

  const previousActiveDotMovementValue = UsePrevious(activeDotMovementValue);

  useEffect(() => {
    const firstExampleElement = document.getElementsByClassName('animate-example')[0];
    firstExampleElement && firstExampleElement.classList.add('parallax');
    const firstResponseElement = document.getElementsByClassName('response-wrapper')[0];
    firstResponseElement && firstResponseElement.classList.add('parallax');
  },[]);

  const slideControlHandler = (oldIndex, newIndex) => {
    if (oldIndex !== newIndex) {
      setUnclickableResponse(false);
      const audioPlayer = document.getElementById('audio-player-survey');
      audioPlayer.pause();
      audioPlayer.src = '';
      const exampleElementsPrevious = document.getElementsByClassName('animate-example')[oldIndex];
      exampleElementsPrevious && exampleElementsPrevious.classList.remove('parallax');
      const responseElementsPrevious = document.getElementsByClassName('response-wrapper')[oldIndex];
      responseElementsPrevious.classList.remove('parallax');

      const responseElements = exampleElementsPrevious && exampleElementsPrevious.nextElementSibling.children || [];
      for (let i = 0; i < responseElements.length; i++ ) responseElements[i].classList.remove('success');
      setTimeout(() => {
        setActiveDotMovementValue(activeDotMovementValue + OnboardingCarousalActiveDotMovementIndex * (newIndex - oldIndex));
      }, 20);
    }
  }

  const afterChangeSlideControlHandler = (index) => setCurrentIndex(index);

  useEffect(() => {
    const exampleElementCurrent = document.getElementsByClassName('animate-example')[currentIndex];
    exampleElementCurrent && exampleElementCurrent.classList.add('parallax');
    const responseElementCurrent = document.getElementsByClassName('response-wrapper')[currentIndex];
    responseElementCurrent && responseElementCurrent.classList.add('parallax');
  }, [currentIndex]);

  const responseHandler = (e, optionId, question, questionKey) => {
    const params = {
      "survey_details": {
          [`${questionKey}`] : `${optionId}`
      },
      "student_id": studentId,
    }

    isNewCoqAbTest ? SubmitSurvey(params) : SubmitOnboardingSurvey(params);

    questionEventHandler({
      'Clicked On': e.target.textContent,
      'Question Index': currentIndex+1,
      question
    })

    setUnclickableResponse(true);
    const targetElement = e.target;
    targetElement.classList.add('success');
    setQuestionResponses({
      ...questionResponses,
      [questionKey]: optionId
    });

    let category = question.options.filter((opt) => opt.id === optionId)[0].category;

    let outcomeData = {
      key: questionKey,
      skill: question.skill_text,
      skillCount: question.skills_count,
      category,
      card: question.ordering,
      contentGroupCode: question.content_group,
      options: question.options,
      questionText: question.text
    }

    if (!questionResponses[questionKey]) {
      setDataforQuestionOutcome([...dataForQuestionsOutcome, outcomeData]);
    } else {
      let res = dataForQuestionsOutcome;
      res[currentIndex] = outcomeData;
      setDataforQuestionOutcome(res);
    }

    setTimeout(() => {
      sliderRef.current && sliderRef.current.slickNext();
    }, 1000)
  }

  //get onboarding survey
  const getOnboardingSurvey = (questionData, questionResponses, getOptionsById, questionText) => {
    var finalResp = {}
    Object.keys(questionResponses).forEach(item => {
      const quesElem = questionData.find(e => e.key == item)
      if (quesElem) {
        let options = quesElem.options;
        if (options && options.length) {
          let option = options.find(o => o.id == questionResponses[item])
          if (option) {
            finalResp[questionText? quesElem.questionText : item] = getOptionsById? option.id : option.text
          }
        }
      }
    })
    return finalResp;
  }

  const submitSurveyAndRedirect = async ({onboardingSurvey, onboardingSurveyById}) =>{
    try{

      isNewCoqAbTest ? await SubmitSurvey({ survey_details: onboardingSurveyById, student_id: studentId, data_dump: true }, true) : await SubmitOnboardingSurvey({ survey_details: onboardingSurveyById, data_dump: true }, true);

      window.localStorage.setItem('onboardingSurvey', JSON.stringify(onboardingSurvey));

      let opt = {
        selectedSubject,
        isLPABTest,
      };
      goToNextHandler(`onboarding_questions_${selectedSubject}`, opt);
    }
    catch(err){
      console.log(err);
    }
  }

  // on submit of the last question
  useEffect (() => {
    if (currentIndex === NumberOfQuestions - 1) {
      let data = attachRestOfTheOutcomeDataAndIndex();
      dispatch(setSkipPersonalized(false));
      dispatch(setQuestionOutcomeData(data, selectedSubject));
      dispatch(setQuestionResponsesData(questionResponses, selectedSubject));
      const onboardingSurvey = getOnboardingSurvey(data, questionResponses, false, true);
      const onboardingSurveyById = getOnboardingSurvey(data, questionResponses, true); // get option by their id
      const key = isLPABTest ? 'Mentor' : subjectCodeMap.get(selectedSubject).title;
      setValue('onboardingQuestionOutcome' + key, data);
      setValue('onboardingResponse' + key, questionResponses);

      submitSurveyAndRedirect({onboardingSurvey, onboardingSurveyById})




    }
  }, [questionResponses]);


  const carousalSettings = {
    dots: true,
    autoplay: false,
    autoplaySpeed: 5000,
    infinite: false,
    slidesToShow: 1,
    swipe: false,
    swipeToSlide: false,
    initialSlide: 0,
    speed: 850,
    arrows: false,
    vertical: true,
    useTransform: true,
    cssEase: 'ease-out',
    customPaging: i => <S.CustomPaginationDot />,
    beforeChange: slideControlHandler,
    afterChange: (index) => afterChangeSlideControlHandler(index)
  };

  const positiveShift = typeof(previousActiveDotMovementValue) === 'undefined' ? true : activeDotMovementValue >= previousActiveDotMovementValue;

  return (
    <S.SliderWrapper activeDotMovementValue={activeDotMovementValue} showTransition={showTransition} isLPABTest={isLPABTest}>
      <Slider {...carousalSettings} ref={sliderRef}>
      {onboardingQuestions && (
        isNewCoqAbTest ? (
          onboardingQuestions.map((que, index) => {
            if (que.text !== 'NA') {
              return (
                <Question
                  questionKey={que.code}
                  question={que}
                  positiveShift={positiveShift}
                  responseHandler={responseHandler}
                  playAudio={playAudio}
                  unclickableResponse={unclickableResponse}
                  questionResponses={questionResponses}
                  questionEventHandler={questionEventHandler}
                  questionIndex={index}
                  currentIndex={currentIndex}
                  setQuestionDetailsForEvent={setQuestionDetailsForEvent}
                  selectedSubject={selectedSubject}
                  childScreenName={childScreenName}
                />
              );
            }
            return null;
          })
        ) : (
          Object.keys(onboardingQuestions).map((que, index) => {
            const question = onboardingQuestions[que];
            if (question.text !== 'NA') {
              return (
                <Question
                  questionKey={que}
                  question={question}
                  positiveShift={positiveShift}
                  responseHandler={responseHandler}
                  playAudio={playAudio}
                  unclickableResponse={unclickableResponse}
                  questionResponses={questionResponses}
                  questionEventHandler={questionEventHandler}
                  questionIndex={index}
                  currentIndex={currentIndex}
                  setQuestionDetailsForEvent={setQuestionDetailsForEvent}
                  selectedSubject={selectedSubject}
                  childScreenName={childScreenName}
                />
              );
            }
            return null;
          })
        )
      )}
      </Slider>
      <audio id="audio-player-survey">
        <source src=""></source>
      </audio>
    </S.SliderWrapper>
  )
}

export default OnboardingQuestionCarousal;